import { enableFamilyInviteV2Flow } from "config";

import FamilyInviteChildSelection from "./FamilyInviteChildSelection";
import FamilyInviteChildSelectionV2 from "./FamilyInviteChildSelectionV2";

export default enableFamilyInviteV2Flow
  ? FamilyInviteChildSelectionV2
  : FamilyInviteChildSelection;
